if (!customElements.get("m-localization-form")) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector('[data-localization-select]');
      select && select.addEventListener('change', (e) => {
        const value = e.target.value
        const form = select.closest('[data-localization-form]')
        const input = form.querySelector('input[data-localization-input]')
        input && input.setAttribute('value', value)

        // Preserve an unpublished theme preview when switching locale/country.
        // On the live storefront there is no preview_theme_id, so this is a no-op.
        const currentUrl = new URL(window.location.href)
        if (currentUrl.searchParams.has('preview_theme_id')) {
          let returnTo = form.querySelector('input[name="return_to"]')
          if (!returnTo) {
            returnTo = document.createElement('input')
            returnTo.type = 'hidden'
            returnTo.name = 'return_to'
            form.appendChild(returnTo)
          }
          returnTo.value = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
        }

        input && form.submit()
      });
    }
  }
  customElements.define('m-localization-form', MLocalizationForm);
}